import axios from "axios";
import { API_BASE_URL } from '../config';

const UserCertificateServices = async (token, userData) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.get(`${API_BASE_URL}user-certificate/`, {
            params: {
                user_id: userData.user_id,
                event_id: userData.event_id
            },
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
}

export default UserCertificateServices;